/* eslint-disable prettier/prettier */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "redux/store";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import AuthService from "services/AuthService";

let persistor = persistStore(store);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Schedule token refresh on app startup if a token exists in localStorage
try {
  const stored = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
  const obj = stored?.data ?? stored ?? null;
  const token =
    obj?.token || obj?.Token || obj?.accessToken || obj?.access_token || null;
  if (token && AuthService && AuthService.scheduleRefresh) {
    AuthService.scheduleRefresh(token);
  }
} catch (e) {
  // ignore
}
